import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import {
  TNetworkSummary,
  TSummary,
  TTransactions,
  TransactionsState,
} from 'store/transactions/types';

export const getTransactionsState = (state: RootState): TransactionsState => state.transactions;

export const getTransactionsData = createSelector(
  [getTransactionsState],
  (state: TransactionsState): TTransactions[] =>
    !state?.data?.transactions
      ? state?.data?.transactions
      : state?.data?.transactions?.map(transaction => ({
          ...transaction,
          amount: transaction?.amount / 100,
        }))
);

export const getCyclePageQueryStrings = createSelector(
  [getTransactionsState],
  (state: TransactionsState): string[] => state?.data?.cycle_page_query_strings ?? []
);

export const getTransactionsSummary = createSelector(
  [getTransactionsState],
  (state: TransactionsState): TSummary =>
    !state?.data?.summary
      ? state?.data?.summary
      : {
          ...state?.data?.summary,
          total_amount_donated_ytd: state?.data?.summary?.total_amount_donated_ytd / 100,
        }
);

export const getTransactionsNetworkSummary = createSelector(
  [getTransactionsState],
  (state: TransactionsState): TNetworkSummary =>
    !state?.data?.network_summary
      ? state?.data?.network_summary
      : {
          ...state?.data?.network_summary,
          total_amount_donated: state?.data?.network_summary?.total_amount_donated / 100,
        }
);
